import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DonationFieldWUT } from '../../../ui/donation-field';
export const DonationWUT = props => {
  const {
    fieldType = FIELD_TYPES.DONATION
  } = props;
  return /*#__PURE__*/React.createElement(DonationFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=donation-wut.js.map